import React from "react";
import Accordion from "components/Accordion";

import {
  FAQ_835_HEADING,
  FAQ_835_ITEMS,
} from "../constants/ImportConversion835Constants";

/**
 * FAQ section for the 835 Import & Conversion page.
 *
 * Each question is its own Accordion instance (the shared component already used across the
 * app), so expanding one question does not affect the others.
 */
export default function Faq835Section() {
  return (
    <div className="import-conversion-835-faq">
      <div className="import-conversion-835-faq-heading">{FAQ_835_HEADING}</div>

      {FAQ_835_ITEMS.map((item) => (
        <div key={item.id} className="import-conversion-835-faq-item">
          <Accordion label={item.question} defaultExpanded={false}>
            <div className="import-conversion-835-faq-answer">
              {item.answer}
            </div>
          </Accordion>
        </div>
      ))}
    </div>
  );
}
